<template>
  <div>
    <static-fullscreen-card v-show="!idItemShow" @sendHeight="cardHeight = $event">
      <template v-slot:header></template>
      <template v-slot:title>
        <v-row class="ma-1">
          <a-btn-menu v-if="getAccess('task.comments', null, true) && false" size="lg" icon="far fa-caret-square-down" :items="panelMenuItems" @click="onClickMenu" />
          <v-menu offset-y v-if="sortItems.length" open-on-hover>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-show="taskViewMode !== 2" v-bind="attrs" v-on="on" :disabled="false" depressed min-width="38" class="mr-1 px-0">
                <v-icon>mdi-sort</v-icon> <v-icon>{{ sortItems.find((s) => s.value == sortType).icon }}</v-icon></v-btn
              >
            </template>
            <v-list>
              <v-list-item-group v-model="sortType" color="primary" @change="onTableRefresh()">
                <v-list-item v-for="(item, index) in sortItems" :key="index" :value="item.value">
                  <v-list-item-icon v-if="item.icon">
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <v-menu offset-y open-on-hover>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" :disabled="false" depressed min-width="38" class="mr-1 px-0"> <v-icon>mdi-filter-cog-outline</v-icon> </v-btn>
            </template>
            <v-list>
              <v-list-item-group :value="taskFilterMode" color="primary" @change="onToggleFilter($event)" multiple mandatory>
                <v-list-item v-for="item in filterItems" :key="item.value" :value="item.value" :inactive="item.disabled" v-if="item.access" v-show="item.show">
                  <v-list-item-icon>
                    <v-icon left class="mx-0"> {{ taskFilterMode.includes(item.value) ? "mdi-checkbox-outline" : "mdi-checkbox-blank-outline" }} </v-icon>
                    <v-icon> {{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <v-btn-toggle v-if="false" v-show="taskViewMode !== 2" class="mr-1" v-model="sortType" mandatory dense @change="onTableRefresh()">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  :value="['id-desc', 'id-asc'].includes(sortType) ? sortType : 'id-desc'"
                  @click="
                    sortType = sortType == 'id-asc' ? 'id-desc' : 'id-asc';
                    onTableRefresh();
                  "
                >
                  <v-icon>
                    {{ sortType == "id-asc" ? "mdi-sort-clock-ascending-outline" : "mdi-sort-clock-descending-outline" }}
                  </v-icon>
                </v-btn>
              </template>
              <span>Старые / Новые</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" value="comment" v-if="getAccess('task.comments', null, true)">
                  <span class="hidden-md-and-down" v-if="false">Сообщения</span>
                  <v-icon> mdi-comment-eye-outline </v-icon>
                </v-btn>
              </template>
              <span>Сообщения</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" value="priority">
                  <v-icon> mdi-alert-outline </v-icon>
                </v-btn>
              </template>
              <span>Приоритет</span>
            </v-tooltip>
          </v-btn-toggle>
          <v-btn-toggle v-if="false" :value="taskFilterMode" dense multiple @change1="onTableRefresh()" @change="onToggleFilter($event)" class="" style="margin-top: 2px">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" :value="0" :disabled="[2, 3, 4].some((item) => taskFilterMode.includes(item))">
                  <v-icon left class="mx-0"> {{ taskFilterMode.includes(0) ? "mdi-checkbox-outline" : "mdi-checkbox-blank-outline" }} </v-icon>
                  <v-icon right> mdi-account </v-icon>
                </v-btn>
              </template>
              <span>Мои задачи</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" :value="1" :disabled="[2, 3, 4].some((item) => taskFilterMode.includes(item))">
                  <v-icon left class="mx-0"> {{ taskFilterMode.includes(1) ? "mdi-checkbox-outline" : "mdi-checkbox-blank-outline" }} </v-icon>
                  <v-icon right> mdi-eye </v-icon>
                </v-btn>
              </template>
              <span>Наблюдатель</span>
            </v-tooltip>
            <v-tooltip v-if="getAccess('task.viewAll')" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" :value="2">
                  <v-icon v-if="false" left class="mx-0"> {{ taskFilterMode.includes(2) ? "mdi-checkbox-outline" : "mdi-checkbox-blank-outline" }} </v-icon>
                  <v-icon right1> mdi-account-multiple </v-icon>
                </v-btn>
              </template>
              <span>Все задачи</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-show="taskViewMode !== 2" v-bind="attrs" v-on="on" :value="3">
                  <v-icon> mdi-robot </v-icon>
                </v-btn>
              </template>
              <span>Автозадачи</span>
            </v-tooltip>
            <v-tooltip v-if="is_director" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class1="mr-1" v-bind="attrs" v-on="on" :value="4">
                  <v-icon> mdi-account-eye </v-icon>
                </v-btn>
              </template>
              <span>Мой отдел</span>
            </v-tooltip>
            <v-tooltip v-if="getAccess('task.viewOverseer')" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class1="mr-1" v-bind="attrs" v-on="on" :value="5">
                  <v-icon> mdi-emoticon-devil-outline </v-icon>
                </v-btn>
              </template>
              <span>Руководители</span>
            </v-tooltip>
          </v-btn-toggle>
          <v-btn-toggle v-model="taskViewMode" dense mandatory @change="showCronList = taskViewMode == 1" class="ml-1" style="margin-top: 2px">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="#d0bf9c" class1="mr-1" v-bind="attrs" v-on="on">
                  <v-icon> fas fa-tasks </v-icon>
                </v-btn>
              </template>
              <span>Таблица</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="#d0bf9c" class1="mx-1" v-bind="attrs" v-on="on">
                  <v-icon> mdi-calendar-clock-outline </v-icon>
                </v-btn>
              </template>
              <span>Расписаниe</span>
            </v-tooltip>
            <v-tooltip v-if="(getAccess('task.viewAll') && $root.profile.role == 1000) || true" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="#d0bf9c" class1="mx-1" v-bind="attrs" v-on="on">
                  <v-icon> mdi-view-dashboard-outline </v-icon>
                </v-btn>
              </template>
              <span>Канбан</span>
            </v-tooltip>
          </v-btn-toggle>
          <portal-target name="v-task-group" />
        </v-row>
      </template>
      <template v-slot:actions>
        <div v-if="modeRedirect">
          <a-btn-add @click="tryRedirect()" :disabled="loading" icon="fas fa-people-arrows" title="" />
          <a-btn-add @click="modeRedirect = false" :disabled="loading" icon="fas fa-ban" title="" />
        </div>
        <div v-else>
          <v-btn v-if="showCronList" color="primary" @click="createNewCron()"> Создать расписание </v-btn>
          <a-btn-add v-if="!showCronList" :color="'primary'" :title="'Создать задачу'" size="lg" @click="createNew()" />

          <a-btn-refresh color="primary" @click="updateData()" size="lg" />
          <a-btn-add v-if="!showCronList && taskViewMode !== 2" @click="modeRedirect = true" :disabled="loading" icon="fas fa-people-arrows" title="" />
        </div>
      </template>
      <portal to="v-main">
        <task-dialog v-if="showTaskDialog" v-model="showTaskDialog" :id="idEdit"></task-dialog>
      </portal>
      <div v-if="taskViewMode == 2">
        <view-canban
          style1="overflow: hidden"
          ref="tasksCanban"
          :api="api"
          :model="model"
          :height="cardHeight - 44"
          :statusList="statuses"
          :defaults="defaults"
          :config="{ taskFilterMode }"
          @show-card="idItemShow = $event"
          @click-task="onClickTask($event)"
          @click-action="onClickAction($event)"
        />
      </div>
      <a-table-f-api
        v-if="!showCronList && taskViewMode !== 2"
        ref="table"
        :api="url"
        :model="model"
        :useQuery="false"
        :defaults="defaults"
        :selectedRows="selectedRows"
        @click="
          counter += 1;
          onDetectClick($event);
        "
        @change-filter="onChangeFilter($event)"
        @rowContextMenu="onRowContextMenu($event)"
        @dataUpdated="dataMdf()"
      />
      <a-table-f-api
        v-if="showCronList && taskViewMode !== 2"
        ref="tableCron"
        :api="'/mechti/cron_tasks'"
        :model="modelCron"
        :useQuery="false"
        :defaults="{
          sort: [
            // { key: 'unviewedscomments_total', order: 'DESC' },
            { key: 'id', order: 'DESC' },
          ],
          paramName: 'taskCron',
        }"
        :selectedRows="selectedRows"
        @click="
          counter += 1;
          onDetectClick($event);
        "
        @change-filter="onChangeFilter($event)"
      />
      <popup-menu v-model="popumMenuShow" :items="popupMenuList" :position="popupMenuPosition" />
    </static-fullscreen-card>
    <RedirectTask v-if="showRedirectDialog" v-model="showRedirectDialog" @redirect="onRedirect($event)" />
    <cron-dialog v-model="showCronDialog" v-if="showCronDialog" :id="idEdit"></cron-dialog>
    <ViewItem v-if="idItemShow" :idShow="idItemShow" :api="url" @close="itemShowClose($event)" />
    <context-menu ref="rowContextMenu" :items="contextMenuItems" @clickData="onContextMenuClick($event)" />
  </div>
</template>

<script>
//import taskDialog from "./dialogs/taskDialog.vue";
//import cronDialog from "./dialogs/taskCronDialog.vue";
import { getAccess, doubleClickDetect, popupMenu } from "@/components/mixings";

export default {
  mixins: [getAccess, doubleClickDetect, popupMenu],
  components: {
    taskDialog: () => import("./dialogs/taskDialog"),
    cronDialog: () => import("./dialogs/taskCronDialog"),
    ViewItem: () => import("./views/tasksView"),
    RedirectTask: () => import("./dialogs/taskRedirectDialog"),
    viewCanban: () => import("./views/tasks/tasksCanban.vue"),
  },
  data() {
    return {
      taskFilterMode: [0, 1],
      taskViewMode: 2,
      sortType: "comment",
      view: 1,
      idEdit: 0,

      cardHeight: 400,
      loading: false,
      idItemShow: 0,
      dialog: false,
      redirectList: null,
      modeRedirect: false,
      showRedirectDialog: false,
      showTaskDialog: false,
      showCronList: false,
      showCronDialog: false,
      mCron: this.$store.getters["config/get"].models.cron,
      m: this.$store.getters["config/get"].models.tasks,
      statuses: this.$store.getters["config/get"].models.tasks.statuses,
      url: "/mechti/tasks",
      filterName: "task",
      isTaskSelf: true,
      isTaskWatch: false,
      contextData: null,
      sortItems_: [
        {
          name: "byDate",
          text: "Старые / Новые",
          value: ["id-desc", "id-asc"].includes(this.sortType) ? this.sortType : "id-desc",
          icon: this.sortType == "id-asc" ? "mdi-sort-clock-ascending-outline" : "mdi-sort-clock-descending-outline",
        },
        { name: "byComment", text: "Сообщения", value: "comment", icon: "mdi-comment-eye-outline" },
        { name: "byPrioritet", text: "Приоритет", value: "priority", icon: "mdi-alert-outline" },
      ],
    };
  },
  created() {
    const filters = this.$root.getSessionFilter(this.filterName);
    if (this.$attrs?.view) {
      if (this.$attrs.view == "cards") this.taskViewMode = 2;
    }
    this.$root.title = "Задачи " + (filters ? "(отфильтрованы)" : "");
    this.defaults.sessionFilters = filters || null;
    this.$root.$on("websocket", this.checkData);
  },
  destroyed() {
    this.$root.$off("websocket", this.checkData);
  },
  computed: {
    sortItems() {
      const res = [
        {
          name: "byDateAsc",
          text: "Сначала старые",
          value: "id-asc",
          icon: "mdi-sort-clock-ascending-outline",
        },
        {
          name: "byDateDesc",
          text: "Сначала новые",
          value: "id-desc",
          icon: "mdi-sort-clock-descending-outline",
        },
        { name: "byComment", text: "Сообщения", value: "comment", icon: "mdi-comment-eye-outline" },
        { name: "byPrioritet", text: "Приоритет", value: "priority", icon: "mdi-alert-outline" },
      ];
      return res;
    },
    filterItems() {
      const res = [
        { value: 0, title: "Мои задачи", icon: "mdi-account", access: true, show: true, disabled: false && [2, 3, 4].some((item) => this.taskFilterMode.includes(item)) },
        { value: 1, title: "Наблюдатель", icon: "mdi-eye", access: true, show: true, disabled: false && [2, 3, 4].some((item) => this.taskFilterMode.includes(item)) },
        {
          value: 2,
          title: "Все задачи",
          icon: "mdi-account-multiple",
          access: this.getAccess("task.viewAll"),
          show: true,
          disabled: false,
        },
        { value: 3, title: "Автозадачи", icon: "mdi-robot", access: true, show: this.taskViewMode !== 2, disabled: false },
        { value: 4, title: "Мой отдел", icon: "mdi-account-eye", access: this.is_director, show: true, disabled: false },
        { value: 5, title: "Руководители", icon: "mdi-emoticon-devil-outline", access: this.getAccess("task.viewOverseer"), show: true, disabled: false },
      ];
      return res;
    },
    is_director() {
      return !!(this.$root.profile?.my_departments || []).length;
    },
    api() {
      return this.taskFilterMode.includes(2) ? "mechti/tasks-admin" : "mechti/tasks";
    },
    panelMenuItems() {
      return [
        {
          text: "Отметить все комментарии прочитанными",
          action: async () => {
            await this.$axios.post(this.url + "/set_viewed_comments");
            this.$store.dispatch("state/badges", "task_comments");
            this.updateData();
          },
        },
      ];
    },
    defaults() {
      let filters = {};
      let where = {};
      if (this.taskFilterMode.includes(4)) this.taskFilterMode = this.taskFilterMode.filter((f) => f !== 3);
      if (this.taskFilterMode.includes(3) && this.getAccess("task.viewAll")) {
        this.url = "/mechti/tasks-admin";
      } else if (this.taskFilterMode.includes(2)) {
        this.url = "/mechti/tasks-admin";
      } else if (this.taskFilterMode.includes(4)) {
        this.url = "/mechti/tasks-department-director";
      } else if (this.taskFilterMode.includes(5)) {
        this.url = "/mechti/tasks-department-director-overseer";
      } else {
        this.url = "/mechti/tasks";
        if (this.taskFilterMode.includes(0) && this.taskFilterMode.includes(1)) {
        } else if (this.taskFilterMode.includes(0)) {
          //мои
          where = { OR: [{ user_id: this.$root.profile.id }, { createdby_id: this.$root.profile.id }] };
          //where.OR[({ user_id: this.$root.profile.id }, { createdby_id: this.$root.profile.id })];
        } else if (this.taskFilterMode.includes(1)) {
          //наблюдатель
          where = {
            AND: [{ user_id: { condition: "<>", value: `${this.$root.profile.id}` } }, { createdby_id: { condition: "<>", value: `${this.$root.profile.id}` } }],
          };
        }
      }
      if (this.taskViewMode === 2) where["AND"] = [...(where?.["AND"] || []), { type: { condition: "=", value: "planning" } }];
      else where["AND"] = [...(where?.["AND"] || []), { type: { condition: this.taskFilterMode.includes(3) ? "=" : "<>", value: "auto" } }];

      let sort = [];
      if (this.sortType == "id-asc") sort.push({ key: "id", order: "ASC", default: true });
      if (this.sortType == "comment") sort.push({ key: "unviewedscomments_total", order: "DESC", default: true });
      if (this.sortType == "id-desc" || this.sortType == "comment") sort.push({ key: "id", order: "DESC", default: true });
      if (this.sortType == "priority") sort = [{ key: "is_important", order: "DESC", default: true }];
      // if (this.isTaskSelf) filters;
      //'type':'auto', 'user_id':user.id, status:0
      return {
        sort,
        filters,
        paramName: "task",
        where,
      };
    },
    contextMenuItems() {
      let res = [
        { name: "viewThis", title: `Отметить эту задачу просмотренной`, disabled: !!this.contextData?.row?.viewedon },
        { name: "viewAll", title: `Отметить ВСЕ задачи просмотренными` },
        { name: "viewComments", title: `Отметить комментарии прочитанными`, disabled: !this.contextData?.row?.unviewedscomments_total },
        {
          name: "viewCommentsAll",
          title: "Отметить ВСЕ комментарии прочитанными",
          action: async () => {
            await this.$axios.post(this.url + "/set_viewed_comments");
            this.$store.dispatch("state/badges", "task_comments");
            this.updateData();
          },
        },
      ];
      return res;
    },
    statusList() {
      let list = [];
      //return this.statuses;
      let idx;
      let type = {
        new: "*Новые",
        progress: "*В процессе",
        ready: "*Завершенные",
        cancel: "*Отмененные",
        checking: "*В процессе",
      };
      const status = this.statuses.filter((s) => s.type == "task");
      let text;
      for (const s of status.filter((el) => el.status)) {
        text = type[s.status] || s.status;
        idx = list.findIndex((el) => el.text == text);
        if (idx > -1) {
          list[idx].value.push(s.value);
        } else {
          list.push({ value: [s.value], text });
        }
      }
      for (const s of status) {
        idx = list.findIndex((el) => el.text == s.text);
        if (idx > -1) {
          list[idx].value.push(s.value);
        } else {
          list.push({ value: [s.value], text: s.text });
        }
      }
      return list;
    },
    model() {
      /**заменяем отображение даты конца на др элемент. с подсветкой */
      let model = this.m.list.copy();
      const status = this.statuses.filter((el) => {
        return ["ready", "cancel"].includes(el?.status);
      });
      //  console.log("m.list", model, this.m.list);
      model.forEach((el) => {
        if (el.name == "date_end") {
          el.type = "dateColor";
          el.status = status.map((s) => {
            return s.value;
          });
        }
        if (el.name == "user_name") {
          // el.textColor = "user_viewedon";
          el.textColor = (values) => {
            return values.user_viewedon ? "" : "red";
          };
        }
        if (el.name == "status") {
          el.search = this.statusList;
        }
        if (el.name == "type") {
          let idx;
          let comment = this.getAccess("task.comments", null, true);
          if (!comment) el.badgeField = null;
          let list = []; //this.m[el.sourceList] || [];
          const types = this.$store.getters["config/get"].config.dictionary.tasksType;

          //   for (const s of this.m["types"].sort()) {
          for (const s of types.sort()) {
            if (s.value == "construction-goods") {
            } else {
              idx = list.findIndex((el) => el.text == s.text);
              if (idx > -1) {
                list[idx].value.push(s.value);
              } else {
                list.push({ value: [s.value], text: s.text });
              }
            }
          }
          //  el.search = list;
        }

        if (el?.sourceList) {
          el.options = this.m[el.sourceList];
        }
      });

      model = [
        {
          name: "checked",
          type: "checkbox",
          width: 35,
          isDisableFunc: (r) => {
            return ([0, 1, 100, 101, 200, 201].includes(r.status) && this.canRedirect) || r.user_id == this.$root.profile.id;
            return true;
          },
          hidden: !this.modeRedirect,
        },
        ...model,
      ];
      return model;
    },
    canRedirect() {
      return this.getAccess("task.redirect");
    },
    modelCron() {
      let model = JSON.parse(JSON.stringify(this.mCron.list));
      model.forEach((el) => {
        if (el?.sourceList) {
          el.options = this.mCron[el.sourceList];
        }
      });
      return model;
    },
  },
  watch: {
    taskViewMode(v) {
      this.$router.push({ query: { view: v == 2 ? "cards" : undefined } });
    },
    showTaskDialog() {
      if (!this.showTaskDialog) {
        this.updateData();
      }
    },
    showCronDialog() {
      if (!this.showCronDialog) {
        this.$refs.tableCron.updateData();
      }
    },
  },

  methods: {
    onToggleFilter(newVal) {
      const group = [2, 3, 4, 5];
      const selectedGroup = newVal.filter((v) => group.includes(v));
      if (group.includes(newVal[newVal.length - 1])) {
        this.taskFilterMode = newVal.filter((v) => v == newVal[newVal.length - 1]);
      } else {
        this.taskFilterMode = newVal.filter((v) => !group.includes(v));
      }
      this.onTableRefresh();
      return;
      if (selectedGroup.length > 1) {
        // Оставляем только последнюю нажатую из группы
        const lastSelected = selectedGroup[selectedGroup.length - 1];

        // Обновляем selected: оставляем все НЕ в группе, + последнюю из группы
        this.taskFilterMode = newVal.filter((v) => !group.includes(v)).concat([lastSelected]);
      } else {
        // Нет конфликта — просто сохраняем выбор
        this.taskFilterMode = newVal;
      }

      this.onTableRefresh();
    },
    getColor(row) {
      let currentDate = new Date();
      let date_end = new Date(row.date_end);
      let date_start = new Date(row.date_start);
      // console.log(date_start.date, currentDate.date);
      if (date_start > currentDate) return `green lighten-4`;
      //green lighten-4
      if (date_start.date == currentDate.date) return "lime lighten-4";
      //lime lighten-4
      if (date_start.addDays(1).date == currentDate.date) return "#F0F4C3";
      //lime lighten-4
      return "#FFCDD2";

      if (date_end < currentDate) return "#FFCDD2"; //red lighten-4
      if (date_start > currentDate) return "#F0F4C3"; //lime lighten-4

      return null;
    },
    async dataMdf() {
      let name = "table";
      if (!this.$refs?.[name].data) return;
      //return;
      for (let i = 0; i < this.$refs[name].data.length; i++) {
        const d = this.$refs[name].data[i];
        if (d?.type == "auto") {
          if (!d._row) {
            let color = this.getColor({ date_end: d.date_end, date_start: d.date_start });
            d._row = { style: `background-color: ${color};`, field: color };
            //console.log(d.id, "get color ", d._row);
          }
          this.$refs[name].$forceUpdate();
        }
      }
    },
    checkData(data) {
      if (data?.event == "updated" && data?.model == "TaskModel") {
      } else if (data?.event == "updated" && data?.model == "CommentModel" && data?.data?.target_name == "tasks") {
      } else return;
      console.log("refresh tasks");
      this.$refs.table.refresh();
    },

    tryRedirect() {
      let error = "";
      this.redirectList = null;
      let rows = [];
      for (let row of this.$refs.table.data.filter((el) => {
        return el?.checked;
      })) {
        rows.push(row);
      }
      if (!rows.length) {
        error = "Ничего не выбранно!";
        return false;
      }

      if (!error)
        rows = rows.filter((el) => {
          console.log("row", el.id, el.status);
          return [0, 1, 100, 101, 200, 201].includes(el.status);
        });

      let userOld;
      if (!error)
        rows.forEach((el) => {
          if (userOld && el.user_id != userOld) {
            error = "Выбраны задачи разных пользователей!";
            return false;
          }
          userOld = el.user_id;
        });
      if (!error) this.redirectList = rows;

      if (!error) this.showRedirectDialog = true;
      else {
        this.$root.$emit("show-info", {
          text: error,
          type: "error",
        });
      }
    },

    async onRedirect(data) {
      if (!this.redirectList) return;
      let d = [];
      this.redirectList.forEach((el) => {
        d.push(Object.assign({}, data, { id: el.id }));
      });

      this.loading = true;
      let response = await this.$axios.post("/mechti/tasks/redirect", d);
      this.loading = false;
      let status = response.data.status == "ok";
      if (status) {
        this.$root.$emit("show-info", {
          text: "Задачи переназначена",
        });
        this.updateData();
      } else {
        this.$root.$emit("show-info", {
          type: "error",
          text: "Ошибка при переназначении",
        });
      }
    },
    async onContextMenuClick(e) {
      if (e.item.name == "viewThis") {
        await this.$axios.post(this.url + "/set_viewed", { ids: [e.data.id] });
        this.$store.dispatch("state/badges", "task_items");
        this.$refs.table.updateRowData(e.data.id);
      }
      if (e.item.name == "viewAll") {
        this.loading = !this.loading;
        await this.$axios.post(this.url + "/set_viewed");
        this.$store.dispatch("state/badges", "task_items");
        this.updateData();
      }
      if (e.item.name == "viewComments") {
        await this.$axios.post(this.url + "/set_viewed_comments", { ids: [e.data.id] });
        this.$store.dispatch("state/badges", "task_comments");
        this.$refs.table.updateRowData(e.data.id);
      }
      if (e.item.name == "viewCommentsAll") {
        e.item.action();
        this.$store.dispatch("state/badges", "task_comments");
        this.$refs.table.updateRowData(e.data.id);
      }
    },
    onRowContextMenu(e) {
      this.contextData = e;
      this.$refs.rowContextMenu.showMenu(e.event, e.row);
    },
    onClickMenu(e) {
      if (e.action) e.action();
    },
    onTableRefresh() {
      setTimeout(() => {
        this.doRefresh();
      }, 100);
    },
    doRefresh() {
      if (this.taskViewMode === 2) {
        this.$refs.tasksCanban.refresh();
      } else this.$refs.table.init();
    },
    itemShowClose(v) {
      console.log("itemShowClose", v);
      this.loading = true;
      if (this.taskViewMode == 2) {
        this.$refs.tasksCanban.refresh();
      } else {
        this.$refs.table.updateRowData(this.idItemShow);
      }
      this.$store.dispatch("state/badges", "task");
      this.loading = !true;
      this.idItemShow = 0;
    },

    updateData() {
      if (this.taskViewMode === 2) {
        this.$refs.tasksCanban.refresh();
        return;
      }
      if (this.showCronList) {
        this.$refs.tableCron.updateData();
      } else {
        this.$refs.table.updateData();
      }
    },

    onSingleClick(d) {
      if (d.field?.isMenu) {
        if (d.field.name == "type") {
          let menuItems = [
            {
              name: "type",
              title: "Отметить комментарии прочитанными",
              action: async () => {
                await this.$axios.post("mechti/tasks/set_viewed_comments", { ids: [d.row.id] });
                this.$store.dispatch("state/badges", "task_comments");
                this.$refs.table.updateRowData(d.row.id);
              },
            },
          ];
          if (d.row.unviewedscomments_total) this.showPopupMenu(d.field.name, d.row, d.event, { menuItems });
        } else this.showPopupMenu(d.field.name, d.row, d.event);
      }
    },
    onDoubleClick(d) {
      console.log("onDoubleClick");
      if (this.showCronList) {
        this.showCronDialogFun(d.row.id);
        this.showCronDialog = true;
      } else {
        this.idItemShow = d.row.id;
        return;
        this.$router.push({ name: "tasks_view", params: { id: d.row.id } });
      }
    },

    createNew() {
      this.showTaskDialogFun(0);
    },

    showTaskDialogFun(id) {
      this.idEdit = id;
      this.showTaskDialog = true;
    },
    createNewCron() {
      this.showCronDialogFun(0);
    },
    showCronDialogFun(id) {
      this.idEdit = id;
      this.showCronDialog = true;
    },
    async updateTask(row) {
      await this.$axios.post(this.url, row);
      this.$root.$emit("show-info", {
        text: "Данные записаны",
      });
    },
    onChangeFilter(f) {
      this.$root.setSessionFilter(this.filterName, f);
    },
  },
};
</script>
